(function () {
  'use strict';

  const API_CONFIG = {
    baseUrl: window.SHOP_API_CONFIG && window.SHOP_API_CONFIG.baseUrl ? window.SHOP_API_CONFIG.baseUrl : 'https://shophyve.kingbriefs.com',
    apiMode: window.SHOP_API_CONFIG && window.SHOP_API_CONFIG.apiMode ? window.SHOP_API_CONFIG.apiMode : 'production',
    defaultHeaders: {
      'Content-Type': 'application/json'
    },
    cache: {},
    defaultCacheTTL: 5 * 60 * 1000
  };

  const TEST_DATA = {
    subscription: {
      storeId: '1',
      productId: '8394129768630',
      data: {
        status: 200,
        data: {
          product: {
            id: "gid://shopify/Product/8392374354102",
            title: "Example Product",
            sellingPlanGroups: {
              edges: [
                {
                  node: {
                    id: "gid://shopify/SellingPlanGroup/1146650705",
                    name: "Subscription Plan",
                    merchantCode: "SUB-001",
                    sellingPlans: {
                      edges: [
                        {
                          node: {
                            id: "gid://shopify/SellingPlan/1816690769",
                            name: "Every 1 month - 10% off",
                            category: "SUBSCRIPTION",
                            options: ["Deliver every 1 month", "Every month - 10% off", "New Print Monthly"],
                            billingPolicy: {
                              __typename: "SellingPlanRecurringBillingPolicy",
                              interval: "MONTH",
                              intervalCount: 1
                            },
                            deliveryPolicy: {
                              __typename: "SellingPlanRecurringDeliveryPolicy",
                              interval: "MONTH",
                              intervalCount: 1
                            },
                            inventoryPolicy: {
                              reserve: "ON_SALE"
                            },
                            pricingPolicies: [
                              {
                                __typename: "SellingPlanFixedPricingPolicy",
                                adjustmentType: "PERCENTAGE",
                                adjustmentValue: {
                                  __typename: "SellingPlanPricingPolicyPercentageValue",
                                  percentage: 10
                                }
                              }
                            ]
                          }
                        },
                        {
                          node: {
                            id: "gid://shopify/SellingPlan/1816723537",
                            name: "Every 2 months - 20% off",
                            category: "SUBSCRIPTION",
                            options: ["Deliver every 2 months"],
                            billingPolicy: {
                              __typename: "SellingPlanRecurringBillingPolicy",
                              interval: "MONTH",
                              intervalCount: 2
                            },
                            deliveryPolicy: {
                              __typename: "SellingPlanRecurringDeliveryPolicy",
                              interval: "MONTH",
                              intervalCount: 2
                            },
                            inventoryPolicy: {
                              reserve: "ON_SALE"
                            },
                            pricingPolicies: [
                              {
                                __typename: "SellingPlanFixedPricingPolicy",
                                adjustmentType: "PERCENTAGE",
                                adjustmentValue: {
                                  __typename: "SellingPlanPricingPolicyPercentageValue",
                                  percentage: 20
                                }
                              }
                            ]
                          }
                        }
                      ]
                    }
                  }
                }
              ]
            }
          }
        }
      }
    },
    bundle: {
      status: 200,
      data: {
        id: "4",
        title: "template 1",
        description: "dev\n",
        type: "BUNDLE",
        status: "ACTIVE",
        platform_id: "gid://shopify/DiscountAutomaticNode/1369033965750",
        starts_at: "2026-01-29T03:30:00.000Z",
        ends_at: null,
        created_at: "2026-01-29T10:00:20.866Z",
        updated_at: "2026-01-29T10:00:20.973Z",
        store: {
          id: "1",
          name: "shopHyve-sevi"
        },
        config: {
          bundles: [
            {
              id: 4,
              name: "template 1",
              tiers: [
                { percentage: 5, minQuantity: 2 },
                { percentage: 8, minQuantity: 3 },
                { percentage: 10, minQuantity: 4 },
                { percentage: 15, minQuantity: 5 },
                { percentage: 18, minQuantity: 6 },
                { percentage: 23, minQuantity: 7 },
                { percentage: 25, minQuantity: 8 },
                { percentage: 28, minQuantity: 9 },
                { percentage: 30, minQuantity: 10 }
              ],
              products: [],
              isEnabled: true,
              description: "dev\n",
              isAllProduct: true
            }
          ]
        }
      },
      meta: { message: "success" }
    }
  };

  function getCacheKey(endpoint, params) {
    return `${endpoint}_${JSON.stringify(params || {})}`;
  }

  function getCachedData(cacheKey, ttl = API_CONFIG.defaultCacheTTL) {
    const cached = API_CONFIG.cache[cacheKey];
    if (!cached) return null;
    
    const now = Date.now();
    if (now - cached.timestamp < ttl) {
      return cached.data;
    }
    
    delete API_CONFIG.cache[cacheKey];
    return null;
  }

  function setCachedData(cacheKey, data) {
    API_CONFIG.cache[cacheKey] = {
      data,
      timestamp: Date.now()
    };
  }

  async function request(endpoint, options = {}) {
    const {
      method = 'GET',
      params = {},
      body = null,
      headers = {},
      cache = false,
      cacheTTL = API_CONFIG.defaultCacheTTL,
      baseUrl = API_CONFIG.baseUrl
    } = options;

    const cacheKey = cache ? getCacheKey(endpoint, params) : null;
    
    if (cache && cacheKey) {
      const cachedData = getCachedData(cacheKey, cacheTTL);
      if (cachedData) {
        console.log(`📦 Using cached data for: ${endpoint}`);
        return cachedData;
      }
    }

    const url = `${baseUrl.replace(/\/$/, '')}${endpoint}`;
    
    const fetchOptions = {
      method,
      headers: {
        ...API_CONFIG.defaultHeaders,
        ...headers
      }
    };

    if (body) {
      fetchOptions.body = JSON.stringify(body);
    }

    try {
      console.log(`🌐 API Request: ${method} ${url}`);
      const response = await fetch(url, fetchOptions);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API Error ${response.status}: ${errorText}`);
      }

      const data = await response.json();

      if (cache && cacheKey) {
        setCachedData(cacheKey, data);
      }

      return data;
    } catch (error) {
      console.error(`❌ API Request Failed: ${method} ${url}`, error);
      throw error;
    }
  }

  function clearCache(pattern = null) {
    if (!pattern) {
      API_CONFIG.cache = {};
      console.log('🗑️ All cache cleared');
      return;
    }

    Object.keys(API_CONFIG.cache).forEach(key => {
      if (key.includes(pattern)) {
        delete API_CONFIG.cache[key];
      }
    });
    console.log(`🗑️ Cache cleared for pattern: ${pattern}`);
  }

  async function getSubscriptionPlans(storeId, productId, options = {}) {
    // Mock模式：返回固定假数据
    if (API_CONFIG.apiMode === 'mock') {
      console.log('🎭 Mock Mode: Using mock subscription data');
      return Promise.resolve(TEST_DATA.subscription.data);
    }
    
    // Debug模式：使用测试产品ID
    if (API_CONFIG.apiMode === 'debug') {
      console.log('🔧 Debug Mode: Using test product ID', TEST_DATA.subscription.productId);
      productId = TEST_DATA.subscription.productId;
    }
    
    const endpoint = `/api/v1/subscription/public/product-plans/${storeId}/${productId}`;
    return request(endpoint, {
      cache: true,
      cacheTTL: options.cacheTTL,
      ...options
    });
  }

  async function getDiscount(discountId, options = {}) {
    // Mock模式和Debug模式：返回固定假数据
    if (API_CONFIG.apiMode === 'mock' || API_CONFIG.apiMode === 'debug') {
      console.log(`🎭 ${API_CONFIG.apiMode === 'mock' ? 'Mock' : 'Debug'} Mode: Using mock bundle data`);
      return Promise.resolve(TEST_DATA.bundle);
    }
    
    const endpoint = `/api/v1/discounts/${encodeURIComponent(discountId)}`;
    return request(endpoint, {
      cache: true,
      cacheTTL: options.cacheTTL,
      ...options
    });
  }

  window.ApiClient = {
    request,
    getSubscriptionPlans,
    getDiscount,
    clearCache,
    config: API_CONFIG
  };

  console.log('✅ ApiClient initialized:', {
    baseUrl: API_CONFIG.baseUrl,
    bundleDiscountId: window.SHOP_API_CONFIG ? window.SHOP_API_CONFIG.bundleDiscountId : 'not set',
    apiMode: API_CONFIG.apiMode === 'mock' ? '🎭 MOCK' : API_CONFIG.apiMode === 'debug' ? '🔧 DEBUG' : '🌐 PRODUCTION'
  });
})();
